import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Content} from '../../../shared/content/content.txt';
import {BaseWebservice} from '../../../shared/base/base.webservice';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../modules/auth';
import {StripeService} from 'ngx-stripe';
import {ProcessService} from '../../_services/process.service';
import {environment} from '../../../../environments/environment';
import Swal from "sweetalert2";

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']
})
export class ReviewComponent  implements OnInit {
    content: Content
    processListing = []
    handler: any;
    loading = false
    elements
    details
    plan = null

    // @ViewChild(StripePaymentElementComponent) paymentElement: StripePaymentElementComponent
    constructor(

        private _globalService: BaseWebservice,
        private route: ActivatedRoute,
        private router: Router,
        private _cd:ChangeDetectorRef,
        private authService: AuthService,
        private stripeService: StripeService,
        private processService: ProcessService

    ) {

        this.processListing = _globalService.getCompleteProcess()
    }


    goToDashboard(){

        window.open(
            'https://www.wisernow.com.au', '_blank' /* */);

    }

    ngOnInit(): void {
        this.processService.getUserDetails().subscribe(response => {
            if(response['success'] == true) {
                this.details = response['data']
                this.plan = response['data'].plan

            } else {
            }
        })
    }

    checkoutsilver(plan, number) {

        let planInt = + plan
        if(planInt == number){
            this.router.navigate([`/download`])
            return
        }

        // this.processService.createPaySession().subscribe(response => {
        //     this.stripeService.redirectToCheckout({ sessionId: response['id'] })
        // })
        //   .pipe(
        //     switchMap(session => {
        //     })
        //   )
        //   .subscribe(result => {
        //     // If `redirectToCheckout` fails due to a browser or network
        //     // error, you should display the localized error message to your
        //     // customer using `error.message`.
        //     if (result.error) {
        //       alert(result.error.message);
        //     }
        //   });

        // this.processService.createPayIntent({
        //     plan: '1'
        // }).subscribe(response => {
        //     this.stripeService.elements({
        //         clientSecret: response['client_secret'],
        //         // Fully customizable with appearance API.
        //         appearance: {/*...*/},
        //     }).subscribe(val => {
        //         this.elements = val
        //         let paymentElement = this.elements.create('payment', {})
        //         paymentElement.mount('#payment-element')

        //         // this.stripeService.createToken(paymentElement, {email: 'test@test.com'}).subscribe(result => {
        //         //     this.
        //         // })
        //     })
        // })

        // const appearance = {
        //     theme: 'stripe',
        //   };
        // const stripe = (<any>window).Stripe(environment.stripeKey)
        // let elements = stripe.elements({ appearance, clientSecret: response['client_secret'] });
        // const paymentElement = elements.create('payment')
        // paymentElement.mount("#payment-element");
        // stripe.confirmPayment({
        //     elements,
        //     confirmParams: {
        //     // Make sure to change this to your payment completion page
        //     return_url: "http://localhost:4242/checkout.html",
        //     },
        // });
        // })

        this.handler = (<any>window).StripeCheckout.configure({
            key: environment.stripeKey,
            // image: '/your-avatar.png',
            locale: 'auto',
            // source: async (source) => {
            //   this.loading = true;
            // //   const user = await this.auth.getUser();
            // //   const fun = this.functions.httpsCallable('stripeCreateCharge');
            // //   this.confirmation = await fun({ source: source.id, uid: user.uid, amount: this.amount }).toPromise();
            // //   this.loading = false;
            token: (token: any, args: any) => {
                this.processService.createPayment({token, plan: '1'}).subscribe(response => {
                    if(response['success']) {
                        this.navigateToNextPage()
                    }
                })
            }
            // }
        });
        this.handler.open({
            name: 'WiserNow Silver Plan',
            // description: 'Card Details',
            email: this.details?.email,
            amount: 9900,
        });




        // this.stripeService.elements({
        //     clientSecret: '{{CLIENT_SECRET}}',
        //     // Fully customizable with appearance API.
        //     appearance: {/*...*/},
        // }).subscribe(val => {
        //     this.elements = val
        //     let paymentElement = this.elements.create('payment', {})
        //     paymentElement.mount('#payment-element')

        //     this.stripeService.createToken(paymentElement, {email: 'test@test.com'}).subscribe(result => {
        //         this.
        //     })
    }
    checkoutGold(plan,number) {

        let planInt = + plan
        if(planInt == number){
            this.router.navigate([`/download`])
            return
        }


        this.handler = (<any>window).StripeCheckout.configure({
            key: environment.stripeKey,
            // image: '/your-avatar.png',
            locale: 'auto',
            // source: async (source) => {
            //   this.loading = true;
            // //   const user = await this.auth.getUser();
            // //   const fun = this.functions.httpsCallable('stripeCreateCharge');
            // //   this.confirmation = await fun({ source: source.id, uid: user.uid, amount: this.amount }).toPromise();
            // //   this.loading = false;
            token: (token: any, args: any) => {
                this.processService.createPayment({token, plan: '1'}).subscribe(response => {
                    if(response['success']) {
                        this.navigateToNextPage()
                    }
                })
            }
            // }
        });
        this.handler.open({
            name: 'WiserNow Gold Plan',
            // description: 'Card Details',
            email: this.details?.email,
            amount: 0,
        });
    }
    checkoutgold() {
        this.handler = (<any>window).StripeCheckout.configure({
            key: environment.stripeKey,
            // image: '/your-avatar.png',
            locale: 'auto',
            // source: async (source) => {
            //   this.loading = true;
            // //   const user = await this.auth.getUser();
            // //   const fun = this.functions.httpsCallable('stripeCreateCharge');
            // //   this.confirmation = await fun({ source: source.id, uid: user.uid, amount: this.amount }).toPromise();
            // //   this.loading = false;
            token: (token: any, args: any) => {
                this.processService.createPayment({token, plan: '1'}).subscribe(response => {
                    if(response['success']) {
                        this.navigateToNextPage()
                    }
                })
            }
            // }
        });
        this.handler.open({
            name: 'WiserNow Gold Plan',
            // description: 'Card Details',
            email: this.details?.email,
            amount: 69900,
        });
    }


    navigateToNextPage() {

        this.router.navigate([`/download`])

    }

    endSession() {
        this.authService.logout()
        this._globalService.setDataAsdefault()
    }


    navigateToStep(id: string) {

        this.router.navigate([`/${id}`])
        setTimeout(args =>
                this._cd.detectChanges()
            ,500)

    }

    getFinishedItem(item: any,list, index) {

        let itemsFinised = list.filter(v => v.isFinished == true);

        if(item.isFinished) return true; else if (itemsFinised.length >0) return itemsFinised.length == index;


    }

    navigateToPage(item, index, listing) {

        if(index ==0){
            this.router.navigate([`/${item.id}`])
        }else{
            let previousSelectedItem = listing[index-1]

            if (previousSelectedItem.isFinished) {
                this.router.navigate([`/${item.id}`])
            } else {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'bottom-left',
                    iconColor: 'white',
                    customClass: {
                        popup: 'colored-toast'
                    },
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                })
                Toast.fire({
                    icon: 'info',
                    title: 'You need to complete previous step before you try to fill  ' + item.label
                })
            }

        }



    }

    expandAccordian(item: any) {

        return item.id == this.activeId
    }

    activeId: string = "";

    toggleAccordian(event) {
        // If it is already open you will close it and if it is closed open it
        this.activeId = this.activeId == event.panelId ? "" : event.panelId;
    }

    getIcon(key, status) {
        let base = "./assets/media/steps/";
        if (status) {
            if (key == "aboutyou") {

                base = base + "step1-active.svg"

            } else if (key == "executor") {
                base = base + "step2-active.svg"

            } else if (key == "estate") {
                base = base + "step3-active.svg"

            } else if (key == "gifts") {
                base = base + "step4-active.svg"

            } else if (key == "funeralwishes") {
                base = base + "step5-active.svg"

            }


        } else {
            if (key == "aboutyou") {

                base = base + "step1-inactive.svg"

            } else if (key == "executor") {
                base = base + "step2-inactive.svg"

            } else if (key == "estate") {
                base = base + "step3-inactive.svg"

            } else if (key == "gifts") {
                base = base + "step4-inactive.svg"

            } else if (key == "funeralwishes") {
                base = base + "step5-inactive.svg"

            }
        }

        return base
    }

    getCtaButtonText(val, defaultValue){

        if(val == null) return "Complete your Will"

        let valInt  =  + val
        if(valInt< defaultValue) return  "Upgrade Plan"
        else  if (valInt ==  defaultValue) return  "Your Plan"
        else return "Not Applicable"


    }

    getPlan(plan: any, number: number) {

    }
}
